<template>
  <div class="download">
    <com-returntop></com-returntop>
    <!-- 下载资料模块 -->

    <div class="download-video" v-if="videoShow">
      <div @click="closeVideo">
        <img class="img-gb" src="/assets/download/guanbi.png" alt="" />
      </div>
      <video :src="src" width="800" height="500" autoplay controls></video>
    </div>
    <img
      class="download-banner"
      src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download/download2.jpg"
      alt=""
    />
    <div class="download-menu">
      <ul>
        <li
          :class="
            activeName == 1 ? 'download-menu-active' : 'download-menu-noactive'
          "
          @click="menuClick(1)"
        >
          <div style="margin-top: -8px; height: 20px">
            循环流化床锅炉机组运行仿真训练
          </div>
          <div style="margin-top: 2px; height: 20px; font-size: 16px">
            （1+X教材配套资料）
          </div>
        </li>
        <li
          :class="
            activeName == 2 ? 'download-menu-active' : 'download-menu-noactive'
          "
          @click="menuClick(2)"
        >
          <div style="margin-top: -8px; height: 20px">
            全国高等院校学生发电机组集控运行技术技能
          </div>
          <div style="margin-top: 2px; height: 20px">竞赛资料</div>
          <div style="padding: 0 50px"></div>
        </li>
        <li
          :class="
            activeName == 3 ? 'download-menu-active' : 'download-menu-noactive'
          "
          @click="menuClick(3)"
        >
          2023年全区职工职业技能竞赛资料
        </li>
      </ul>
    </div>

    <div class="shadow"></div>
    <!-- 循环流化床资料 -->
    <div v-if="activeIndex == 1" class="menu-content">
      <div style="background-color: white; width: 100%">
        <div class="certificate-list">
          <!-- 左侧菜单栏 -->
          <div class="certificate-list-left">
            <div class="toobar">
              <div class="eng">Resource Download</div>
              <div class="eng-font">资料下载</div>
            </div>
            <div style="padding: 15px 10px; font-weight: bold">
              《循环流化床锅炉设备<br />及运行仿真实操演练》
            </div>
            <a style="cursor: pointer" @click="rdio(1)"
              ><div :class="radoFlag == 1 ? 'rado1' : 'rado'">PDF资料</div></a
            ><br />
            <a style="cursor: pointer" @click="rdio(2)"
              ><div :class="radoFlag == 2 ? 'rado1' : 'rado'">下载安装</div></a
            ><br />
          </div>
          <!-- 右侧文章列表 -->
          <div class="certificate-list-right">
            <!-- 证书信息 布局样式 -->
            <div v-if="radoFlag == 1" class="certificate-info">
              <div class="down-list">
                <div class="down-item">
                  <div class="down-item-left">
                    <a
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/materials/220T循环流化床锅炉机组仿真机启动操作指南.pdf"
                      >220T循环流化床锅炉机组仿真机启动操作指南</a
                    ><img src="../assets/1+X/pdf.png" />
                  </div>
                  <div class="down-item-right">2020-09-27</div>
                </div>
                <div class="down-item">
                  <div class="down-item-left">
                    <a
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/materials/220T循环流化床锅炉说明书.pdf"
                      >220T循环流化床锅炉说明书</a
                    ><img src="../assets/1+X/pdf.png" />
                  </div>
                  <div class="down-item-right">2020-09-27</div>
                </div>
                <div class="down-item">
                  <div class="down-item-left">
                    <a
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/materials/220T循环流化床锅炉系统图.pdf"
                      >220T循环流化床锅炉系统图</a
                    ><img src="../assets/1+X/pdf.png" />
                  </div>
                  <div class="down-item-right">2020-09-27</div>
                </div>
                <div class="down-item">
                  <div class="down-item-left">
                    <a
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/materials/220T循环流化床锅炉运行规程.pdf"
                      >220T循环流化床锅炉运行规程.pdf</a
                    ><img src="../assets/1+X/pdf.png" />
                  </div>
                  <div class="down-item-right">2020-09-27</div>
                </div>
              </div>
            </div>
            <div v-if="radoFlag == 2" class="certificate-info">
              <div
                style="
                  font-family: simhei;
                  font-size: 60px;
                  color: rgb(232, 231, 232);
                  font-weight: bold;
                  margin-left: -10px;
                "
              >
                INTRODUCTION
              </div>
              <div
                style="
                  font-family: simhei;
                  font-size: 28px;
                  color: rgb(75, 75, 75);
                  margin-bottom: 48px;
                "
              >
                50MW循环流化床母管制机组仿真系统简介
              </div>
              <div style="font-size: 14px; color: #666666">
                <p>50MW循环流化床母管制机组仿真系统按“三炉三机”配置。</p>
                <p style="font-weight: bold">锅炉部分：</p>
                <p>
                  #3、#4锅炉为济南锅炉厂制造的YG-220/9.8-M1型循环流化床锅炉。锅炉为高压参数、单汽包、自然循环，采用由膜式壁、高温旋风分离器、返料器、流化床组成的循环燃烧系统。
                </p>
                <p>
                  #5锅炉为太原锅炉厂制造的TG-220/9.81-㎡型循环流化床锅炉。锅炉为高温高压，单汽包横置式，单炉膛，自然循环，全悬吊结构，全钢架π型布置。
                </p>
                <p style="font-weight: bold">汽轮机部分：</p>
                <p>
                  #3、#4汽轮机为C50—8.82/0.294型高压、单缸、单轴、冲动、单抽汽凝汽式汽轮机，通过刚性联轴器直接带动发电机工作。
                </p>
                <p>
                  #5汽轮机为B25-8.83/0.294单缸背压式汽轮机，本体主要由转子部分和静子部分组成。转子部分包括整锻转子、叶片、联轴器、主油泵叶轮等；静子部分包括汽缸、蒸汽室、喷嘴组、汽封、轴承、轴承座、调节汽阀等。
                </p>
                <p style="font-weight: bold">发电机部分：</p>
                <p>
                  #1发电机为QF-25-2型空冷三相两极交流同步发电机，额定转速为3000r/min，频率为50HZ。
                </p>
                <p>
                  #3、#4发电机为QF—60—2型三相交流发电机，采用密闭空气自通风循环冷却方式，定子铁芯和绕组采用表面空气冷却，转子绕组由空气直接冷却，励磁方式为同轴交流无刷励磁。
                </p>
              </div>
              <a
                href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/50MW循环流化床母管制机组仿真系统.zip"
                ><img
                  style="margin: 30px 0 45px"
                  src="../assets/download.png"
                  alt=""
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 竞赛资料相关 -->
    <div v-if="activeIndex == 2" class="menu-content">
      <div style="background-color: white; width: 100%">
        <div class="certificate-list">
          <!-- 左侧菜单栏 -->
          <div class="certificate-list-left">
            <div class="toobar">
              <div class="eng">Competition Resource</div>
              <div class="eng-font">竞赛资料</div>
            </div>
            <ul>
              <li v-for="(item, index) in bars">
                <div
                  :class="cateIndex == item ? 'column2' : 'column1'"
                  @click="showToggle(item)"
                >
                  {{ item.name }}
                  <span
                    v-if="cateIndex == item"
                    style="float: right; margin-right: 20px"
                    >></span
                  >
                </div>
                <ul
                  v-if="item.name == '竞赛相关文件'"
                  v-show="isZiLiao"
                  style="font-size: 20px"
                >
                  <li>
                    <a @click="competitionRdio(5)">
                      <div
                        :class="
                          competitionFlag == 5
                            ? 'competitionRado1'
                            : 'competitionRado'
                        "
                      >
                        2023
                      </div>
                    </a>
                    <br />
                  </li>
                  <li>
                    <a @click="competitionRdio(1)">
                      <div
                        :class="
                          competitionFlag == 1
                            ? 'competitionRado1'
                            : 'competitionRado'
                        "
                      >
                        2022
                      </div>
                    </a>
                    <br />
                  </li>
                </ul>
                <ul v-if="item.name == '仿真系统软件'" v-show="isRuanJian">
                  <li>
                    <a @click="competitionRdio(2)">
                      <div
                        :class="
                          competitionFlag == 2
                            ? 'competitionRado1'
                            : 'competitionRado'
                        "
                      >
                        2022
                      </div>
                    </a>
                    <br />
                  </li>
                </ul>
                <ul v-if="item.name == '仿真培训视频'" v-show="isShiPin">
                  <li>
                    <a @click="competitionRdio(3)">
                      <div
                        :class="
                          competitionFlag == 3
                            ? 'competitionRado1'
                            : 'competitionRado'
                        "
                      >
                        2022
                      </div>
                    </a>
                    <br />
                  </li>
                </ul>
                <ul v-if="item.name == '仿真系统操作演示'" v-show="isYanShi">
                  <li>
                    <a @click="competitionRdio(4)">
                      <div
                        :class="
                          competitionFlag == 4
                            ? 'competitionRado1'
                            : 'competitionRado'
                        "
                      >
                        2022
                      </div>
                    </a>
                    <br />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="certificate-list-right" style="min-height: 450px">
            <!--  右侧文章布局样式 -->
            <div v-if="competitionFlag == 1" class="menu-content">
              <div class="titleList">
                <div
                  class="title"
                  v-for="(item, index) in titleList"
                  :key="index"
                  @mouseenter="enter(index)"
                  @mouseleave="leave()"
                  @click="toDetail(index)"
                >
                  <!-- <div
                    :class="styleFlag == index ? 'title-left2' : 'title-left1'"
                  >
                    {{ item.tm.Y }}.{{ item.tm.M }}.{{ item.tm.D }}
                  </div> -->
                  <div class="title-right">
                    <div class="title-title">{{ item.name }}</div>
                    <!-- <div class="title-brief">{{ item.brief }}</div> -->
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <div class="title-page">
                <!-- 如果只有一页 不显示页码及下一页 -->
                <!-- <div v-if="page.pageCount>1"> -->
                <div class="flex">
                  <div
                    v-for="index of page.pageCount"
                    class="box"
                    :class="pageIndex == index ? 'active' : ''"
                    @click="pagetap(index)"
                  >
                    {{ index }}
                  </div>
                </div>
                <div
                  class="box title-page-active"
                  @click="pageto()"
                  style="width: 150px"
                >
                  下一页
                </div>
                <!-- </div> -->
              </div>
            </div>
            <div v-if="competitionFlag == 5" class="menu-content">
              <div class="titleList">
                <div
                  class="title"
                  v-for="(item, index) in titleList"
                  :key="index"
                  @mouseenter="enter(index)"
                  @mouseleave="leave()"
                  @click="toDetail(index)"
                >
                  <!-- <div
                    :class="styleFlag == index ? 'title-left2' : 'title-left1'"
                  >
                    {{ item.tm.Y }}.{{ item.tm.M }}.{{ item.tm.D }}
                  </div> -->
                  <div class="title-right">
                    <div class="title-title">{{ item.name }}</div>
                    <!-- <div class="title-brief">{{ item.brief }}</div> -->
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <div class="title-page">
                <!-- 如果只有一页 不显示页码及下一页 -->
                <!-- <div v-if="page.pageCount>1"> -->
                <div class="flex">
                  <div
                    v-for="index of page.pageCount"
                    class="box"
                    :class="pageIndex == index ? 'active' : ''"
                    @click="pagetap(index)"
                  >
                    {{ index }}
                  </div>
                </div>
                <div
                  class="box title-page-active"
                  @click="pageto1()"
                  style="width: 150px"
                >
                  下一页
                </div>
                <!-- </div> -->
              </div>
            </div>
            <div
              v-if="competitionFlag == 2"
              class="menu-content"
              style="margin-left: 50px; margin-bottom: 20px"
            >
              <h1 class="download-h1" style="font-size: 28px">
                2022年全国高等院校学生发电机组集控运维运行技术技能竞赛仿真系统下载
              </h1>
              <div class="download-list">
                <div class="download-list-title">
                  <div>名称</div>
                  <div>大小</div>
                  <div>下载</div>
                </div>
                <div
                  class="download-list-list"
                  v-for="(item, index) in dataList"
                >
                  <div>{{ item.file_name }}</div>
                  <div>{{ item.file_size }}</div>
                  <div>
                    <p @click="to_download(item.file_id)">
                      <a :href="item.url" download="">Download</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="competitionFlag == 3"
              class="menu-content"
              style="margin-left: 50px"
            >
              <div class="download-movie">
                <div class="download-movie-list" style="width: 1014px">
                  <ul :style="'left:' + left + 'px'">
                    <li
                      v-for="(item, index) in peiXunlist"
                      :key="index"
                      @click="showVideo(item.src)"
                    >
                      <img :src="item.img" alt="" /><span
                        class="peiXunTitle"
                        :title="item.name"
                        >{{ item.name }}</span
                      ><img
                        src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download/bofang.png"
                        class="download-movie-list-img"
                        alt=""
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              v-else-if="competitionFlag == 4"
              class="menu-content"
              style="margin-left: 50px"
            >
              <!-- <h1 class="download-h1">软件</h1> -->
              <div class="download-movie">
                <div class="download-movie-list" style="width: 1014px">
                  <ul :style="'left:' + left + 'px'">
                    <li
                      v-for="(item, index) in list"
                      :key="index"
                      @click="showVideo(item.src)"
                    >
                      <img :src="item.img" alt="" /><span>{{ item.name }}</span
                      ><img
                        src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download/bofang.png"
                        class="download-movie-list-img"
                        alt=""
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeIndex == 3" class="menu-content">
      <div style="background-color: white; width: 100%">
        <div class="certificate-list">
          <!-- 左侧菜单栏 -->
          <div class="certificate-list-left">
            <div class="toobar">
              <div class="eng">Resource Download</div>
              <div class="eng-font">资料下载</div>
            </div>
            <a style="cursor: pointer" @click="rdio(1)"
              ><div :class="radoFlag == 1 ? 'rado1' : 'rado'">
                仿真系统软件
              </div></a
            >
          </div>
          <!-- 右侧文章列表 -->
          <div class="certificate-list-right">
            <!-- 证书信息 布局样式 -->
            <div v-if="radoFlag == 1" class="certificate-info">
              <div class="down-list">
                <div class="down-item">
                  <div class="down-item-left">
                    <a
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/20231129/330MW仿真系统资料.zip"
                      >330MW仿真系统资料.zip</a
                    ><img src="../assets/1+X/zip.png" />
                  </div>
                  <div class="down-item-right">2023-11-29</div>
                </div>
                <div class="down-item">
                  <div class="down-item-left">
                    <a
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/20231129/660MW超超临界仿真系统资料.zip"
                      >660MW超超临界仿真系统资料.zip</a
                    ><img src="../assets/1+X/zip.png" />
                  </div>
                  <div class="down-item-right">2023-11-29</div>
                </div>
                <div class="down-item">
                  <div class="down-item-left">
                    <a
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/20231129/发电集控值班员题库（公布版11.29）.docx"
                      >发电集控值班员题库（公布版11.29）.docx</a
                    ><img src="../assets/1+X/docx.png" />
                  </div>
                  <div class="down-item-right">2023-11-29</div>
                </div>
                <div class="down-item">
                  <div class="down-item-left">
                    <a
                      target="_blank"
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/20231129/仿真系统安装使用演示.mp4"
                      >仿真系统安装使用演示.mp4</a
                    ><img src="../assets/1+X/mp4.png" />
                  </div>
                  <div class="down-item-right">2023-11-29</div>
                </div>
                <div class="down-item">
                  <div class="down-item-left">
                    <a
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/20231129/发电集控运维330MW亚临界机组培训系统2023竞赛版.exe"
                      >发电集控运维330MW亚临界机组培训系统2023竞赛版.exe</a
                    ><img src="../assets/1+X/exe.png" />
                  </div>
                  <div class="down-item-right">2023-11-29</div>
                </div>
                <div class="down-item" style="margin-bottom:55px">
                  <div class="down-item-left">
                    <a
                      href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/20231129/发电集控运维660MW超超临界机组培训系统-2023-2竞赛.exe"
                      >发电集控运维660MW超超临界机组培训系统-2023-2竞赛.exe</a
                    ><img src="../assets/1+X/exe.png" />
                  </div>
                  <div class="down-item-right">2023-11-29</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import comReturntop from "@/components/returntop";
import {
  Article,
  ArChildren,
  timestampToTime,
  Serchdata,
} from "../services/article.js";
export default {
  components: {
    comReturntop,
  },
  data() {
    return {
      dataList: [], // 定义下载列表数据的接收数组
      fileId: -1, // 定义下载次数的对应数据id
      radoFlag: 1,
      competitionFlag: 1,
      activeName: 1,
      left: 0,
      src: "",
      videoShow: false,
      list: [
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/600T.jpg",
          name: "600T垃圾发电仿真系统",
          id: 1,
          src: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/600T%E5%9E%83%E5%9C%BE%E5%8F%91%E7%94%B5%E4%BB%BF%E7%9C%9F%E7%B3%BB%E7%BB%9F.mp4",
        },
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/300MW.png",
          name: "300MW仿真系统",
          id: 2,
          src: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/300MW%E4%BB%BF%E7%9C%9F%E7%B3%BB%E7%BB%9F.mp4",
        },
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/660MW.jpg",
          name: "660MW超超临界仿真系统",
          id: 3,
          src: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/660MW%E8%B6%85%E8%B6%85%E4%B8%B4%E7%95%8C%E4%BB%BF%E7%9C%9F%E7%B3%BB%E7%BB%9F.mp4",
        },
      ],
      peiXunlist: [
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/images/download/02.png",
          name: "2022年度中国电力教育协会火电机组集控运行技术技能赛前培训",
          id: 1,
          src: "https://bernouly.oss-cn-beijing.aliyuncs.com/download/1.2022年度中国电力教育协会火电机组集控运行技术技能赛前培训.mp4",
        },
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/images/download/01.png",
          name: "风机竞赛仿真机培训-电气部分",
          id: 2,
          src: "https://bernouly.oss-cn-beijing.aliyuncs.com/download/2.风机竞赛仿真机培训-电气部分.mp4",
        },
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/images/download/03.png",
          name: "风机竞赛仿真机培训-风机部分",
          id: 3,
          src: "https://bernouly.oss-cn-beijing.aliyuncs.com/download/3.风机竞赛仿真机培训-风机部分.mp4",
        },
      ],
      activeIndex: 1,
      bars: [
        {
          name: "竞赛相关文件",
          subItems: [
            {
              name: "2022",
            },
          ],
        },
        {
          name: "仿真系统软件",
          subItems: [
            {
              name: "2022",
            },
          ],
        },
        {
          name: "仿真培训视频",
          subItems: [
            {
              name: "2022",
            },
          ],
        },
        {
          name: "仿真系统操作演示",
          subItems: [
            {
              name: "2022",
            },
          ],
        },
      ],
      cateIndex: 1,
      isZiLiao: false,
      isShiPin: false,
      isRuanJian: false,
      isYanShi: false,
      dataList: [],
      titleList: [],
      styleFlag: -1,
      pageIndex: 1,
      page: {
        totalCount: 0, //总记录数
        pageCount: 1, //总页数
        currentPage: 0, //当前页
        perPage: 8, //每页显示数量
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryDownload(); // 请求下载列表数据
    this.menuClick(1);
    let clickId = this.$route.query.id;
    if (clickId == 1) {
      this.menuClick(2);
    } else {
      this.menuClick(1);
    }
  },
  methods: {
    // 定义请求下载列表函数
    queryDownload() {
      axios
        .get("http://api.bernouly.com:82/api/queryFileInfo", {
          params: {
            groupId: 2022,
          },
        })
        .then((res) => {
          if (res.data.msg == "查询成功") {
            if (res.data.data.length > 0) {
              this.dataList = res.data.data;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 定义 更新下载次数的函数
    to_download(id) {
      let that = this;
      axios
        .get("http://api.bernouly.com:82/api/updateDownload", {
          params: {
            fileId: id,
          },
        })
        .then((res) => {})
        .catch((error) => {
          console.log(error);
        });
    },
    showToggle: function (item) {
      // 控制菜单显隐
      if (item.name == "竞赛相关文件") {
        this.competitionRdio(1);
        this.isShiPin = false;
        this.isRuanJian = false;
        this.isYanShi = false;
        this.isZiLiao = true;
      } else if (item.name == "仿真系统软件") {
        this.competitionRdio(2);
        this.isShiPin = false;
        this.isZiLiao = false;
        this.isYanShi = false;
        this.isRuanJian = true;
        this.queryDownload(); // 请求下载列表数据
      } else if (item.name == "仿真培训视频") {
        this.competitionRdio(3);
        this.isZiLiao = false;
        this.isRuanJian = false;
        this.isYanShi = false;
        this.isShiPin = true;
      } else if (item.name == "仿真系统操作演示") {
        this.competitionRdio(4);
        this.isZiLiao = false;
        this.isRuanJian = false;
        this.isShiPin = false;
        this.isYanShi = true;
      }

      if ((this.cateIndex = item)) {
        item.isSubShow = !item.isSubShow;
      }
    },
    rdio(index) {
      this.radoFlag = index;
    },
    competitionRdio(index) {
      this.competitionFlag = index;
      if (index == "1") {
        this.article(187, 1);
      }
      if (index == "5") {
        this.article(188, 1);
      }
    },
    menuClick(index) {
      this.activeIndex = index;
      this.activeName = index;
      if (index == 1) {
        this.rdio(1);
      } else if (index == 2) {
        this.showToggle(this.bars[0]);
        this.competitionRdio(5); // 获取2023年竞赛相关文章标题列表
      }
    },
    // 获取文章标题列表
    article(cid, page) {
      this.titleList = [];
      let titleList = [];
      Article({
        category_id: cid,
        page_size: 8,
        page: page,
      }).then((res2) => {
        if (res2.items.length > 0) {
          res2.items.forEach((citem) => {
            //时间格式处理   原有逻辑↓
            //let tm = timestampToTime(citem.release_time);
            //适配java后端需要做时间转换
            let tm = timestampToTime(
              new Date(citem.release_time).getTime() / 1000
            );
            citem.tm = tm;
            titleList.push(citem);
          });
          this.titleList = titleList;
          //处理分页
          this.page.totalCount = res2._meta.totalCount;
          this.page.pageCount = res2._meta.pageCount;
          this.page.currentPage = res2._meta.currentPage;
        }
      });
    },
    // 文章点击跳转文章详情页
    toDetail(index) {
      if (this.titleList[index].content.length < 100) {
        window.open(this.titleList[index].attachment, "_blank");
        return;
      }
      this.$router.push({
        path: "/certificate-active",
        query: {
          id: this.titleList[index].id,
          category_id: this.titleList[index].category_id,
        },
      });
      // 修改公告标题样式风格
      this.leave();
    },
    //鼠标悬浮事件-修改文章标题样式
    enter(index) {
      this.styleFlag = index;
    },
    //鼠标离开事件-修改文章标题样式
    leave() {
      this.styleFlag = -1;
    },
    // 翻页方法
    pagetap(page) {
      this.pageIndex = page; //更新页码样式控制参数
      this.article(187, page);
    },
    // 下一页方法
    pageto() {
      let cid = 0;
      //更新页码样式控制参数
      if (this.pageIndex == this.page.pageCount) {
        this.pageIndex = 1;
      } else {
        this.pageIndex = this.pageIndex + 1;
      }
      this.article(187, this.pageIndex);
    },
    // 下一页方法
    pageto1() {
      let cid = 0;
      //更新页码样式控制参数
      if (this.pageIndex == this.page.pageCount) {
        this.pageIndex = 1;
      } else {
        this.pageIndex = this.pageIndex + 1;
      }
      this.article(188, this.pageIndex);
    },
    jiantouclick(n) {
      if (n == 2) {
        if (this.left - 400 < -2000) {
          return;
        }
        this.left -= 400;
      } else {
        if (this.left + 400 > 0) {
          return;
        }
        this.left += 400;
      }
    },
    showVideo(src) {
      this.src = src;
      this.videoShow = true;
    },
    closeVideo() {
      this.videoShow = false;
    },
    goLearn(index) {
      if (index == 0) {
        this.$router.push({
          path: "/learn10",
        });
      }
    },
  },
};
</script>
<style scoped>
.shadow {
  height: 100px;
  width: 100%;
  background-color: #eeeeee;
}
.rado {
  height: 30px;
  display: inline-block;
  margin-left: 10px;
  background: url(../assets/xuanzhzong_1.png) no-repeat 12px 12px;
  line-height: 34px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 15px;
}

.rado1 {
  height: 30px;
  display: inline-block;
  margin-left: 10px;
  background: url(../assets/xuanzhong.png) no-repeat 12px 12px;
  line-height: 34px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 15px;
}
.competitionRado {
  height: 30px;
  display: inline-block;
  margin-left: 10px;
  background: url(../assets/xuanzhzong_1.png) no-repeat 12px 12px;
  line-height: 34px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 14px;
  cursor: pointer;
}

.competitionRado1 {
  height: 30px;
  display: inline-block;
  margin-left: 10px;
  background: url(../assets/xuanzhong.png) no-repeat 12px 12px;
  line-height: 34px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 14px;
  cursor: pointer;
}
.column1 {
  height: 52px;
  width: auto;
  font-size: 16px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}
.column2 {
  height: 52px;
  width: auto;
  font-size: 16px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  color: #0055d3;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}
.column1:hover,
.column2:hover {
  color: #0055d3;
  cursor: pointer;
}
.peiXunTitle {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.titleList {
  height: auto;
  width: auto;
  margin-top: 30px;
}
.title {
  display: flex;
  margin-left: 50px;
  width: auto;
  height: 60px;
}
.title:hover {
  background-color: #0055d3;
  color: #e6e6e6;
  cursor: pointer;
}
.title-left1 {
  color: #0055d3;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}
.title-left2 {
  color: #e6e6e6;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}

.title-right {
  height: auto;
  padding-top: 13px;
  margin-left: 12px;
  vertical-align: middle;
  line-height: 33px;
}
.title-title {
  font-size: 18px;
  font-weight: bold;
}

.title-title sapn {
  float: right;
}

.title-brief {
  font-size: 14px;
}
.title-page {
  display: flex;
  justify-content: space-between;
  width: auto;
  padding: 0px 20px 0px 75px;
  margin: 90px 0px 70px;
}

.title-page .box {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-right: 2px;
  font-size: 16px;
  color: #333;
  background: #ddd;
}
.title-page .flex {
  display: flex;
}

.title-page .active {
  color: #fff;
  background: #0055d3;
}

.title-page-active:active {
  background: #0055d3;
  color: #fff;
}
.box:hover {
  cursor: pointer;
}

.title-page .flex {
  display: flex;
}

.title-page .active {
  color: #fff;
  background: #0055d3;
}

.title-page-active:active {
  background: #0055d3;
  color: #fff;
}
.certificate-info p {
  line-height: 34px;
}
.download-banner {
  width: 100%;
  height: 300px;
}
.download-h1 {
  height: 130px;
  line-height: 130px;
  text-align: center;
  font-size: 36px;
  color: #333;
}
.download-list {
  width: 1014px;
  margin: 0 auto;
}
.download-list-title {
  height: 50px;
  display: flex;
  line-height: 50px;
}
.download-list-title div {
  background: #0055d3;
  color: #fff;
  padding-left: 20px;
  font-size: 16px;
}
.download-list-title div:nth-child(1) {
  width: 672px;
  margin-right: 2px;
}
.download-list-title div:nth-child(2) {
  width: 231px;
  margin-right: 2px;
}
.download-list-title div:nth-child(3) {
  width: 231px;
}
.download-list-list {
  height: 70px;
  display: flex;
  line-height: 70px;
  color: #333;
  font-size: 16px;
}
.download-list-list:nth-child(2n + 1) {
  background: #fff;
}
.download-list-list div {
  padding-left: 20px;
}
.download-list-list div:nth-child(1) {
  width: 672px;
  margin-right: 2px;
}
.download-list-list div:nth-child(2) {
  width: 231px;
  margin-right: 2px;
}
.download-list-list div:nth-child(3) {
  width: 231px;
  display: flex;
  align-items: center;
}
.download-list-list div:nth-child(3) p {
  width: 136px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 2px solid #0055d3;
  border-radius: 30px;
  background: #fff;
  cursor: pointer;
}
.download-list-list div:nth-child(3) p a {
  color: #0055d3;
}
.download-list-list div:nth-child(3) p:hover a {
  color: #fff;
}
.download-list-list div:nth-child(3) p:hover {
  background: #0055d3;
}
.download {
  background: #eee;
  padding-bottom: 80px;
}

.download-movie {
  /* width: 1200px; */
  margin: 0 auto;
  position: relative;
}

.download-movie-list {
  width: 1014px;
  overflow: hidden;
  position: relative;
  height: 450px;
}
.download-movie-list ul {
  display: flex;
  position: absolute;
  top: 0;
  height: 355px;
}
.download-movie-list li {
  display: flex;
  height: auto;
  position: relative;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}
.download-movie-list li img {
  width: 330px;
  height: 260px;
  margin: 0 2px;
}
.download-movie-list li span {
  margin-top: 20px;
  font-size: 18px;
  color: #333;
}
.download-movie-list li .download-movie-list-img {
  width: 80px;
  height: 80px;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -40px;
  margin-top: -65px;
}
.download-movie .tip {
  width: 50px;
  height: 70px;
  position: absolute;
  font-weight: normal;
  top: 50%;
  margin-top: -70px;
}
.download-movie .tip img {
  width: 100%;
  height: 100%;
  border: 0 none;
  box-shadow: none;
  cursor: pointer;
}
.download-movie-left {
  left: -70px;
}
.download-movie-right {
  right: -70px;
}

.download-video {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
}

.download-video div {
  width: 100%;
  height: 100%;
}

.img-gb {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: 385px;
  margin-top: -242px;
  width: 30px;
  z-index: 101;
}

.img-gb:hover {
  cursor: pointer;
}

.download-video video {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -400px;
  margin-top: -250px;
  z-index: 100;
}
.download-menu {
  width: 1200px;
  background: #fff;
  position: absolute;
  top: 260px;
  height: 80px;
  left: 50%;
  margin-left: -600px;
}
.download-menu ul {
  display: flex;
}

.download-menu li {
  width: 100%;
  cursor: pointer;
  height: 80px;
  font-size: 18px;
  text-align: center;
  line-height: 80px;
}

.download-menu .download-menu-active {
  background: #0a57f4;
  color: #fff;
}
.download-menu-active {
  color: #0a57f4;
}

.download-menu .download-menu-noactive {
  background: #fff;
  color: #333;
}

.certificate-list {
  margin-top: 80px;
  width: 1200px;
  min-height: 450px;
  margin: 0 auto;
  background-color: white;
}

.certificate-list-left {
  float: left;
  width: 185px;
  /* min-height: 450px; */
}

.toobar {
  height: 78px;
  padding-top: 30px;
  border-bottom: 1px solid #6d5c55;
}

.eng {
  font-size: 16px;
  color: #666666;
}

.eng-font {
  font-size: 26px;
}

.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: auto;
  border-left: 1px solid #d4d4d4;
}
.certificate-info {
  min-height: 450px;
  margin-left: 50px;
}
.down-list {
  min-height: 350px;
}

.down-item {
  height: 80px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px #cccccc solid;
  line-height: 80px;
}

.down-item-left {
}
.down-item-left img {
  margin-top: -4px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 20px;
  margin-left: 15px;
}

.down-item-right {
  margin: auto 0;
  margin-right: 20px;
  color: #666666;
}
.down-item-left a:link {
  color: #666666;
}

a:hover,
.down-item-left a:hover {
  color: blue;
}
</style>